import { DirectLinkStatus } from '@src/domains/direct-links';
import { OrderStatus } from '@src/domains/orders';
import { SaleState } from '@src/domains/sales';
import type { Transactable } from '@src/domains/transactables/types/transactable';

export const isTransactableCreated = (tr: Transactable): boolean => {
  if (tr.order) {
    return tr.order.status === OrderStatus.Created;
  }

  if (tr.sale) {
    return tr.sale.state === SaleState.Created;
  }

  if (tr.directLink) {
    return tr.directLink.status === DirectLinkStatus.Created;
  }

  return false;
};
